import {AnswerAtom} from "../atoms";
import React, {useState} from "react";
import {Button, Fade, Stack, Typography} from "@mui/material";
import {useAtom} from "jotai";
import {LocationOnOutlined} from "@mui/icons-material";
import Box from "@mui/material/Box";
import {toast} from "react-toastify";
import useConfirm from "../../../hooks/useConfirm";
import {IconCheck, IconCircleOff, IconMapPin} from "@tabler/icons-react";
import {checkPermissionStatus} from "../../../utils/functions";
import {grey} from "@mui/material/colors";

export const GeoLocationQuestion = () => {
    const [answer, setAnswer] = useAtom(AnswerAtom);
    const [locationAcquired, setLocationAcquired] = useState(null)
    const confirm = useConfirm();

    function geolocateUser() {
        console.log("Granted")
        navigator.geolocation.getCurrentPosition(function (position) {
                setAnswer(prev => {
                    const answerObject = {...prev};
                    answerObject.lng = position.coords.longitude
                    answerObject.lat = position.coords.latitude
                    answerObject.text = position.coords.latitude + "," + position.coords.longitude
                    return {...answerObject};
                })
                toast.success('Location acquired', {duration: 500})
                setLocationAcquired(true)

            },
            function (positionError) {
                if (positionError?.code === 1) {
                    toast.error("Permission denied");
                } else if (positionError?.code === 2) {
                    toast.error("The acquisition of the geolocation failed because at least one internal source of position returned an internal error.");
                } else if (positionError?.code === 3) {
                    toast.error("The acquisition of the geolocation failed because at least one internal source of position returned an internal error.");
                } else {
                    toast.error("Failed to get location")
                }
                setLocationAcquired(false);
                console.log(positionError);
            });
    }

    const handleCheckPermission = async () => {
      const status = await checkPermissionStatus("geolocation");
      if (status === "granted") {
        geolocateUser();
        return;
      }
      let confirmBtn = <Stack direction={"row"} gap={2} alignItems={"center"} sx={{color: "primary.main"}}><IconCheck size={18} /><Typography fontSize={"0.9em"} color={"primary.main"}>OK</Typography></Stack>;
      let cancelBtn =  <Stack direction={"row"} gap={2} alignItems={"center"} sx={{color: "error.main"}}><IconCircleOff size={18} /><Typography fontSize={"0.9em"} color={"error.main"}>Deny</Typography></Stack>;
      const confirmStyle = {bgcolor: "transparent", color: "error", flex: 1, boxShadow: 0, border: 0, borderColor: "primary.main", "&:hover": {bgcolor: grey[50], boxShadow: 0, borderColor: "primary.main"} };
      const cancelStyle = {bgcolor: "transparent", color: "error", flex: 1, boxShadow: 0, border: 0, borderColor: "error.main", "&:hover": {bgcolor: grey[50], boxShadow: 0, borderColor: "error.main"} };

      let response = await confirm(
        <Stack direction={"row"} gap={2} alignItems={"center"} sx={{color: "primary.main"}}><IconMapPin size={18} /><Typography fontSize={"0.9em"} color={"primary.main"}>Share your location</Typography></Stack>,
        "Share your location once for this survey",
        confirmBtn,
        cancelBtn,
        confirmStyle,
        cancelStyle,
      )
      if (response) {
        geolocateUser();
        return;
      }
      // Wait 500ms before showing second modal
      await new Promise(res => setTimeout(res, 500));

      confirmBtn = <Stack direction={"row"} gap={2} alignItems={"center"} sx={{color: "primary.main"}}><IconCheck size={18} /><Typography fontSize={"0.9em"} color={"primary.main"}>Share</Typography></Stack>;
      response = await confirm(
        <Stack direction={"row"} gap={2} alignItems={"center"} sx={{color: "primary.main"}}><Typography fontSize={"0.9em"} fontWeight={600} color={"primary.main"}>Are you sure?</Typography></Stack>,
        "This is your only chance to add your location.",
        confirmBtn,
        cancelBtn,
        confirmStyle,
        cancelStyle,
      )
      if (response) {
        geolocateUser();
      }
    }

    return (
        <>

            <Fade in={!!answer?.imgUrl} timeout={1000}>
                <Box sx={{maxHeight: "45dvh", textAlign: 'center'}}>
                    <img src={answer?.imgUrl} alt={answer?.title} width={"100%"} height={"auto"}
                         style={{objectFit: "contain", maxHeight: "45dvh"}}/>
                </Box>
            </Fade>

            {locationAcquired && <Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
                <LocationOnOutlined color={"success"}/>
                <Typography>Location Acquired Successfully</Typography>
            </Stack>}

            {!locationAcquired &&
                <Button startIcon={<LocationOnOutlined/>}
                        variant={"outlined"}
                        onClick={handleCheckPermission}>Acquire location</Button>}

            <Typography
              component={answer?.link ? "a" : "p"}
              href={answer?.link || undefined}
              target={answer?.link ? "_blank" : undefined}
              align={"center"} fontWeight={500} fontSize={"0.9rem"}
            >
              {answer?.bottomExplainer}
            </Typography>
        </>
    )
}
